import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UploadPage from "./UploadPage";
import KiteDisplayPage from "./KiteDisplayPage";
import HandMapper from "./HandMapper";

function App() {
  const [kiteUrls, setKiteUrls] = useState([]); // store uploaded kites

  return (
    <Router>
      <Routes>
        <Route path="/" element={<UploadPage setKiteUrls={setKiteUrls} />} />
        <Route path="/display" element={<KiteDisplayPage kiteUrls={kiteUrls} />} />
        <Route path="/hand" element={<HandMapper kiteUrls={kiteUrls} />} />
      </Routes>
    </Router>
  );
}

export default App;
